import { API_BASE_URL } from '../apiConfig';

/** Grades API base (defaults to main API …/api). Override with REACT_APP_GRADES_API_URL if needed. */
export const GRADES_API_BASE_URL = (
  process.env.REACT_APP_GRADES_API_URL || API_BASE_URL
).replace(/\/$/, '');

export const GRADES_TENANT_ID = process.env.REACT_APP_GRADES_TENANT_ID || 'tenant5';
